/* @flow */
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';

import BoxBody from 'components/BoxBody.jsx';
import Button from 'components/Button.jsx';
import Dialog from 'components/Dialog.jsx';
import focusNode from 'utils/focusNode';

/**
 * A simple dialog for displaying a message with a single button.
 *
 * # Use with [ModalTrigger](/components/ModalTrigger)
 *
 * ```example
 * <ModalTrigger
 *   modal={
 *     <AlertDialog>
 *       <div>
 *         Hello World!
 *       </div>
 *     </AlertDialog>
 *   }>
 *   <Button>Show dialog</Button>
 * </ModalTrigger>
 * ```
 */

class AlertDialog extends React.Component {
  static propTypes = {
    ...Dialog.propTypes,
    /** */
    closeLinkText: React.PropTypes.string,
    onOkay: React.PropTypes.func,
    buttonText: React.PropTypes.string,
    size: React.PropTypes.oneOf(['xlarge', 'large', 'medium', 'small', 'xsmall']),
  };

  static defaultProps = {
    buttonText: 'OK',
    size: 'xsmall',
  };

  handleButtonClick = () => {
    this.requestHide();
    if (this.props.onOkay) {
      this.props.onOkay();
    }
  };

  requestHide = () => {
    this.props.onRequestHide();
  };

  render() {
    const { closeLinkText } = this.props;
    return (
      <Dialog
        {...this.props}
        className={cx('AlertDialog', this.props.className)}
        size={this.props.size}>
        <BoxBody>
          {this.props.children}
          <Button
            className="AlertDialog-okButton"
            onClick={this.handleButtonClick}
            ref={component => focusNode(ReactDOM.findDOMNode(component))}
            eventElementName="AlertDialog-okButton">
            {this.props.buttonText}
          </Button>
          {closeLinkText &&
            <div>
              <Button
                level="text"
                onClick={this.requestHide}>
                {closeLinkText}
              </Button>
            </div>
          }
        </BoxBody>
      </Dialog>
    );
  }
}

export default AlertDialog;



// WEBPACK FOOTER //
// ./src/components/AlertDialog.jsx